import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { RG_INTERACTION_STATUSES } from '@xanadu/ui-shared/modules/user/data';
import Generic from './components/Generic';
import CasinoLoss from './components/CasinoLoss';
import CasinoSession from './components/CasinoSession';
import ExchangeLoss from './components/ExchangeLoss';
import useRgInteractionAck from './api';

import styles from '../RgInteraction/RgInteraction.module.scss';
import KnowYourLimits from './components/KnowYourLimits/KnowYourLimits';
import CasinoLossAuto from './components/CasinoLossAuto/CasinoLossAuto';

const {
  CASINO_SESSION,
  CASINO_LOSS,
  CASINO_LOSS_AUTO,
  EXCHANGE_LOSS,
  GENERIC,
  DEPOSITS,
} = RG_INTERACTION_STATUSES;

const RgInteraction = ({
  closeModal,
  rgInteractionStatus,
  rgInteractionData,
  history,
  currency
}) => {
  const showCasinoLoss = rgInteractionStatus === CASINO_LOSS;

  const showCasinoLossAuto = rgInteractionStatus === CASINO_LOSS_AUTO;

  const showCasinoSession = rgInteractionStatus.includes(CASINO_SESSION);

  const showExchangeLoss = rgInteractionStatus.includes(EXCHANGE_LOSS);

  const showGeneric = rgInteractionStatus.includes(GENERIC);

  const showKnowYourLimits = rgInteractionStatus.includes(DEPOSITS);

  const totalDeposit = rgInteractionData && rgInteractionData.get('totalDeposits');

  const depositLast24Hours = rgInteractionData && rgInteractionData.get('depositsLast24hCount');

  const casinoLossesLast7Days = rgInteractionData && rgInteractionData.get('casinoLossesForLast7Days');

  const casinoLossesLastDay = rgInteractionData && rgInteractionData.get('casinoLossesForLastDay');

  const closeRgPopup = () => {
    useRgInteractionAck('DISMISS');

    closeModal();
  };

  const goToRgTools = useCallback(() => {
    useRgInteractionAck('REVIEW');

    closeModal();

    const timer = setTimeout(() => {
      history.push('/page/rules_and_regulations/responsible-gambling');
    }, 240);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={styles.main}>
      {showGeneric && (
        <Generic
          closeRgPopup={closeRgPopup}
          goToRgTools={goToRgTools}
        />
      )}
      {showCasinoLoss && (
        <CasinoLoss
          closeRgPopup={closeRgPopup}
          goToRgTools={goToRgTools}
        />
      )}
      {showCasinoSession && (
        <CasinoSession
          closeRgPopup={closeRgPopup}
          goToRgTools={goToRgTools}
        />
      )}
      {showExchangeLoss && (
        <ExchangeLoss
          closeRgPopup={closeRgPopup}
          goToRgTools={goToRgTools}
        />
      )}
      {showKnowYourLimits && (
        <KnowYourLimits
          closeRgPopup={closeRgPopup}
          goToRgTools={goToRgTools}
          currency={currency}
          totalDeposit={totalDeposit}
          depositLast24Hours={depositLast24Hours}
        />
      )}
      {showCasinoLossAuto && (
        <CasinoLossAuto
          closeRgPopup={closeRgPopup}
          goToRgTools={goToRgTools}
          currency={currency}
          casinoLossesLast7Days={casinoLossesLast7Days}
          casinoLossesLastDay={casinoLossesLastDay}
        />
      )}
    </div>
  );
};

RgInteraction.propTypes = {
  closeModal: PropTypes.func.isRequired,
  rgInteractionStatus: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  rgInteractionData: PropTypes.object,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }),
};

export default RgInteraction;

